import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { PropTypes, describe } from 'react-desc';
import { aggregatedClasses } from '@elliemae/ds-classnames';

var blockName = 'breadcrumb';

function DSBreadcrumbItem(_ref) {
  var _ref$containerCompone = _ref.containerComponent,
      containerComponent = _ref$containerCompone === void 0 ? 'li' : _ref$containerCompone,
      _ref$as = _ref.as,
      LinkComponent = _ref$as === void 0 ? 'a' : _ref$as,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$href = _ref.href,
      href = _ref$href === void 0 ? undefined : _ref$href,
      isTitle = _ref.isTitle,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {
    return null;
  } : _ref$onClick,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      rest = _objectWithoutProperties(_ref, ["containerComponent", "as", "active", "href", "isTitle", "onClick", "label"]);

  var CrumbWrapper = aggregatedClasses(containerComponent)(blockName, 'crumb', function (_ref2) {
    var a = _ref2.active,
        title = _ref2.title;
    return {
      active: a,
      title: title
    };
  });
  var Link = aggregatedClasses(LinkComponent)(blockName, 'label');
  return /*#__PURE__*/React.createElement(CrumbWrapper, _extends({
    "aria-current": active ? 'page' : undefined,
    "data-testid": "breadcrumb-item-container",
    classProps: {
      active: active,
      title: isTitle
    }
  }, rest), /*#__PURE__*/React.createElement(Link, {
    href: href,
    onClick: onClick
  }, label));
}

var props = {
  /** inject props to wrapper */
  containerComponent: PropTypes.string.description('inject props to wrapper'),

  /** render as any html node */
  as: PropTypes.string.description('render as any html node'),

  /** active item */
  active: PropTypes.bool.description('active item'),

  /** href link */
  href: PropTypes.string.description('href link'),

  /** on click handler */
  onClick: PropTypes.func.description('on click handler'),

  /** style item as title */
  isTitle: PropTypes.bool.description('style item as title'),

  /** add trailing slash */
  trailingSlash: PropTypes.bool.description('add trailing slash'),

  /** item label */
  label: PropTypes.string.description('item label')
};
DSBreadcrumbItem.propTypes = props;
var DSBreadcrumbItemWithSchema = describe(DSBreadcrumbItem);
DSBreadcrumbItemWithSchema.propTypes = props;

export default DSBreadcrumbItem;
export { DSBreadcrumbItem, DSBreadcrumbItemWithSchema };
//# sourceMappingURL=DSBreadcrumbItem.js.map
